import React from "react";
import { useTranslation } from "react-i18next";

const FilterBtn = ({ onClickHandler }: { onClickHandler: () => void }) => {
  const { t } = useTranslation("filter");
  return (
    <button className="my-transactions__btn my-transactions__btn--filter" type="button" onClick={onClickHandler}>
      <span className="material-icons material-icons-round" role="img" aria-label={t("filter")} title={t("filter")}>
        &#xE152;
      </span>
      {t("filter")}
    </button>
  );
};

export default FilterBtn;
